var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!(_vm.name === '404' || _vm.name === 'login' || _vm.name === 'register'))?_c('comHeader',{staticClass:"comHeader"}):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"con"}),_vm._v(" "),(!(_vm.name === '404'))?_c('comFooter',{staticClass:"comHeader"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-047c0bed","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 